import { fetchAPI } from "../../../config/api";
import { POSITION_COORDS } from "../constants";

export async function fetchHeadshotMap(playerIds) {
  if (!playerIds.length) return {};
  const bulk = await fetchAPI("/players/bulk", {
    method: "POST",
    body: JSON.stringify({ player_ids: playerIds }),
  });
  const map = {};
  Object.entries(bulk || {}).forEach(([pid, info]) => {
    if (info?.headshot_url) map[pid] = info.headshot_url;
  });
  return map;
}

async function fetchPlayerPositions(playerId, year, division) {
  const data = await fetchAPI(
    `/player/${playerId}/positions?year=${year}&division=${division}&role=batting`
  );
  return data?.summary || [];
}

export async function buildPositionMap(players, year, division) {
  const results = await Promise.all(
    players.map(async (player) => {
      try {
        const summary = await fetchPlayerPositions(player.id, year, division);
        return { player, summary };
      } catch {
        return { player, summary: [] };
      }
    })
  );

  const map = {};
  results.forEach(({ player, summary }) => {
    summary.forEach(({ position, games }) => {
      const pos = position?.split("/")[0]?.trim().toUpperCase();
      if (!pos || !POSITION_COORDS[pos]) return;
      if (!map[pos]) map[pos] = [];
      map[pos].push({ id: player.id, name: player.name, games });
    });
  });

  Object.keys(map).forEach((pos) => {
    map[pos].sort((a, b) => b.games - a.games);
  });

  return map;
}
